import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.EDIT_SHIPPING_USER.REQUEST, saga.editShippingUser);
    yield takeLatest(ACTION.EDIT_SHIPPING_USER.SUCCESS, saga.editShippingUserSuccess);
}
